module.exports = __webpack_public_path__ + "static/media/file.fd3e15f8.svg";